import React from "react";
import { NavLink } from "react-router-dom";
import { Home, Building2, FileText, ShoppingBag, Users } from "lucide-react";
import { useNotifications } from "../../context/NotificationContext";

const items = [
  { to: "/",           label: "Home",       Icon: Home,       testid: "nav-home",       section: null },
  { to: "/businesses", label: "Businesses", Icon: Building2,  testid: "nav-businesses", section: "businesses" },
  { to: "/enquiries",  label: "Enquiries",  Icon: FileText,   testid: "nav-enquiries",  section: "enquiries" },
  { to: "/orders",     label: "Orders",     Icon: ShoppingBag,testid: "nav-orders",     section: "orders" },
  { to: "/employees",  label: "Employees",  Icon: Users,      testid: "nav-employees",  section: "employees" },
];

export function BottomNav() {
  const { counts } = useNotifications();
  return (
    <nav
      data-testid="vc-bottom-nav"
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md bg-white border-t border-slate-100 flex justify-around items-stretch h-[68px] pb-1 z-50 shadow-[0_-4px_20px_rgba(0,0,0,0.04)] lg:hidden"
    >
      {items.map(({ to, label, Icon, testid, section }) => {
        const badge = section ? (counts?.by_section?.[section] || 0) : 0;
        const negBadge = section ? (counts?.by_section_negative?.[section] || 0) : 0;
        const badgeColor = negBadge > 0 ? "bg-red-500" : "bg-emerald-500";
        return (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            data-testid={testid}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-0.5 w-full transition-all duration-200 ${
                isActive ? "text-emerald-600" : "text-slate-400"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <div
                  className={`relative w-12 h-8 rounded-full flex items-center justify-center transition-all duration-200 ${
                    isActive ? "bg-emerald-50" : ""
                  }`}
                >
                  <Icon className="w-[18px] h-[18px]" strokeWidth={isActive ? 2.5 : 2} />
                  {badge > 0 && (
                    <span
                      data-testid={`${testid}-badge`}
                      className={`absolute -top-0.5 right-1 min-w-[16px] h-[16px] px-1 rounded-full ${badgeColor} text-white text-[10px] font-bold grid place-items-center leading-none`}
                    >
                      {badge > 9 ? "9+" : badge}
                    </span>
                  )}
                </div>
                <span className={`text-[10px] leading-none tracking-tight ${isActive ? "font-bold" : "font-medium"}`}>
                  {label}
                </span>
              </>
            )}
          </NavLink>
        );
      })}
    </nav>
  );
}
